import { qs, toggleHidden } from '../utils/dom.js';
import debounce from '../utils/debounce.js';

export default class SearchOverlay {
  constructor(root, { onSearch }) {
    this.root = root;
    this.onSearch = onSearch;
    this.panel = qs('[data-search-panel]', root);
    this.openBtn = qs('[data-open-search]', root);
    this.closeBtn = qs('[data-close-search]', root);
    this.input = qs('[data-search-input]', root);

    if (!this.input) return;

    if (!this.panel || !this.openBtn || !this.closeBtn) {
      this.inline = true;
      this.bindInline();
      return;
    }

    this.bindEvents();
  }

  bindEvents() {
    this.openBtn.addEventListener('click', () => this.open());
    this.closeBtn.addEventListener('click', () => this.close());
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !this.panel.hidden) {
        this.close();
      }
    });
    this.input.addEventListener(
      'input',
      debounce(event => {
        this.onSearch?.(event.target.value.trim());
      }, 250)
    );
  }

  bindInline() {
    this.input.addEventListener(
      'input',
      debounce(event => {
        this.onSearch?.(event.target.value.trim());
      }, 250)
    );
  }

  open() {
    if (!this.input) return;
    if (this.inline || !this.panel) {
      this.input.focus();
      return;
    }
    toggleHidden(this.panel, false);
    this.input.focus();
  }

  close() {
    if (!this.input) return;
    if (this.inline || !this.panel) {
      this.input.value = '';
      this.onSearch?.('');
      return;
    }
    toggleHidden(this.panel, true);
    this.input.value = '';
    this.onSearch?.('');
    this.openBtn.focus();
  }

  setValue(value) {
    if (!this.input) return;
    this.input.value = value;
  }
}
